import { render, staticRenderFns } from "./AtopicDermatitisSymptomLevel.vue?vue&type=template&id=b2e4b5fc&scoped=true&"
import script from "./AtopicDermatitisSymptomLevel.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitisSymptomLevel.vue?vue&type=script&lang=js&"
import style0 from "./AtopicDermatitisSymptomLevel.vue?vue&type=style&index=0&id=b2e4b5fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e4b5fc",
  null
  
)

export default component.exports